export const antTheme = {
  token: {
    fontFamily: 'Montserrat',
  },
};
